import KhaltiCheckout  from "khalti-checkout-web";

export const getKhalti =(config)=>{
    let checkout = new KhaltiCheckout(config);
    return checkout;
}